import React, { Component } from 'react';

// 组件
import {
  DataTable,
  Icon,
  Checkbox,
  FormLayout,
  TextField,
  Pagination,
  Button,
  Spinner,
  Tooltip,
  BlockStack,
  Modal,

} from '@shopify/polaris';
import AddKeywordsModal from "../../../../components/AddKeywordsModal"
import ImportKeywordsModal from "../../../../components/ImportKeywordsModal"
import DeleteModal from "../../../../components/DeleteModal"
import EmptyTableTip from '../../../../components/EmptyTableTip';
// 样式+图标
import {
  SearchMinor,

} from "@shopify/polaris-icons";
import KeywordsResearchDeleteIcon from '../../../../assets/KeywordsResearchDeleteIcon';
import KeywordsResearchInsert from '../../../../assets/KeywordsResearchInsert'
// import KeywordsResearchAdded from '../../../../assets/KeywordsResearchAdded'
import FooterPageSelect from '../../../../components/FooterPageSelect';
import { connect } from "react-redux";

import '../index.css';
// 接口
import {
  reqGetKeywordsLibrary, reqHandleKeywordsLibraryList, reqAddKeywords
} from '../../../../api';
import ApplyKeywordList from '../../../../components/ApplyKeywordList';
//翻译包
import Language from '../../../../i18n/Language';
import { debounce } from 'lodash';
const t = Language

class KeywordList extends Component {

  state = {
    myKeywordsRow: [],
    myKeywordsListLength: 0,

    loading: true,
    // 排序
    orderBy: '',
    sortIndex: 1,
    orderBydirection: 'descending', //当前排序值
    headingIndex: 3, //默认排序选项
    // 搜索停顿
    delay: 0,
    // 搜索内容
    searchValue: '',
    // 分页
    page: 1,
    total: 0,
    hasPrevious: false,
    hasNext: true,
    size: 10,
    // 是否显示空页面
    isEmpty: false,
    // 所选择的ID
    tableInputID: [],
    tableCheckChecked: [],

    ScoreStautsArr: [],

    table: [],
    //全选
    checked: false,
    //添加关键词弹窗开关
    openAddKeywordsStatus: false,
    //导入关键词弹窗开关
    openImportKeywordsStatus: false,
    //删除弹窗开关
    openDeleteStatus: false,
    //删除保存状态
    delSaveStatus: false,

    deleteArr: [],

    //批量添加的状态
    addLoadingStatus: false,

    loadingArr: [],
    //解决删除后 全选按钮和下方多个checkbox不同步的问题
    delStatus: false,

    current_PageSize: 10, // 表格条数
    userServices: this.props.userServices,

    applyModalState: false,
    applyKeywordVal: '', // 申请的关键词
    applyData: {}, // 选中数据
    applyLists: {},
    homeKey: '',
    isShowKeywordExit: false, // 关键词存在提示
    exitNums: 0, // 存在数量
    applyLoading: false,
  };

  shouldComponentUpdate(nextProps) {
    if(nextProps.userServices !== this.props.userServices) {
      this.setState({
        userServices: nextProps.userServices
      })
    }
    return true;
  }

  changeCheckbox = (index, value) => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    var tableCheckArray = this.state.tableCheckChecked;
    tableCheckArray[index] = !tableCheckArray[index];

    //判断选中的数量
    var SelectedQuantity = 0;
    for (var i = 0; i < tableCheckArray.length; i++) {
      if (tableCheckArray[i] === true) {
        SelectedQuantity += 1;
      }
    }
    var checked = false;
    if (SelectedQuantity === 0) {
      checked = false;
    } else {
      checked = true;
    }
    this.setState({
      tableCheckChecked: tableCheckArray,
      myKeywordsListLength: SelectedQuantity,
      checked,
    }, () => {
      this.updateKeywordsList()
    })
  }

  handleChangeAllCheckbox = () => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    var tableCheckArray = this.state.tableCheckChecked;
    if (!this.state.checked) {
      for (let i = 0; i < tableCheckArray.length; i++) {
        tableCheckArray[i] = true
        this.setState({
          myKeywordsListLength: tableCheckArray.length,
          tableCheckChecked: tableCheckArray,
          checked: true
        }, () => {
          this.updateKeywordsList()
        })
      }
    } else {
      for (let i = 0; i < tableCheckArray.length; i++) {
        tableCheckArray[i] = false
        this.setState({
          tableCheckChecked: tableCheckArray,
          checked: false
        }, () => {
          this.updateKeywordsList()
        })
      }
    }
  }

  // 搜索事件
  handleSearchChange = (val) => {
    this.setState({
      searchValue: val,
    }, () => {
      this.queryGetKeywordsLibrary();
    })
  }

  handleSort = async (headingIndex, direction) => {
    var order = '';
    if (direction === 'descending') {
      order = 'DESC';
    } else if (direction === 'ascending') {
      order = 'ASC';
    }
    var index;
    if (headingIndex === 4) {
      index = 1;
    } else if (headingIndex === 3) {
      index = 2;
    } else if (headingIndex === 6) {
      index = 3;
    } else if (headingIndex === 5) {
      index = 4;
    }
    this.setState({
      headingIndex: headingIndex,
      orderBydirection: direction,
      orderBy: order,
      sortIndex: index,
      loading: true,
    }, () => {
      this.getKeywordsLibrary('sort')
    })
  }

  // 点击打开添加关键词弹窗
  openAddKeywordsModal = () => {
    this.setState({
      openAddKeywordsStatus: true
    })
  }

  // 添加关键词弹窗组件关闭 子组件传值到父组件
  AddKeywordsChildrenChange = (val) => {//这个val就是子组件传来的
    this.setState({
      openAddKeywordsStatus: val
    })
  }

  // 点击打开导入关键词弹窗
  openImportKeywordsModal = () => {
    this.setState({
      openImportKeywordsStatus: true
    })
  }

  // 导入关键词弹窗组件关闭 子组件传值到父组件
  ImportKeywordsChildrenChange = (val) => {//这个val就是子组件传来的
    this.setState({
      openImportKeywordsStatus: val
    })
  }

  // 点击打开删除弹窗
  openDeleteModal = (id) => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    this.setState({
      openDeleteStatus: true,
      deleteArr: id
    })
  }

  //关闭删除弹窗
  CloseDeletePop = (val) => {
    this.setState({
      openDeleteStatus: val,
      deleteArr: []
    })
  }

  // 删除弹窗组件关闭 子组件传值到父组件
  DeleteChildrenChange = (val, deleteArr) => {//这个val就是子组件传来的
    this.setState({
      delSaveStatus: true
    })
    this.DeletedKeywords(deleteArr).then(res => {
      this.setState({
        openDeleteStatus: val,
        delSaveStatus: false,
        delStatus: true, //删除请求成功后将状态改为true
      }, () => {
        this.getKeywordsLibrary()
      })
      
    })
  }


  //删除
  DeletedKeywords = async (IDArr) => {
    const params = {
      type: 2,
      idArr: IDArr
    }
    const response = await reqHandleKeywordsLibraryList(params)
    if (response.code === "200") {
      this.props.toggleToast(response.msg, false);
    } else {
      this.props.toggleToast(response.msg, true);
    }
  }


  //批量删除
  batchDeleteModal = (tableCheckChecked, tableInputID) => {
    var deleteArr = []
    for (let i = 0; i < tableCheckChecked.length; i++) {
      if (tableCheckChecked[i] === true) {
        deleteArr.push(tableInputID[i])
      }
    }
    this.openDeleteModal(deleteArr)
  }

  //单个添加
  showInsertIcon = async (id, index) => {
    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show();
      return;
    }

    let loadingArr = this.state.loadingArr;
    loadingArr[index] = true;
    this.setState({
      loadingArr
    }, () => {
      this.updateKeywordsList()
    })
    const params = {
      type: 1,
      idArr: id,
    }
    const response = await reqHandleKeywordsLibraryList(params)
    if (response.code === "200") {
      let table = this.state.table
      table[index].is_add = true
      loadingArr[index] = false;
      this.setState({
        table,
        loadingArr
      }, () => {
        this.updateKeywordsList()
        this.props.toggleToast(response.msg, false)
      })
    } else {
      this.props.toggleToast(response.msg, true)
    }
  }

  //批量添加
  batchAddModal = async (tableCheckChecked, tableInputID) => {
    this.setState({
      addLoadingStatus: true
    })

    let idArr = []
    for (let i = 0; i < tableCheckChecked.length; i++) {
      if (tableCheckChecked[i] === true) {
        idArr.push(tableInputID[i])
      }
    }

    const params = {
      type: 1,
      idArr: idArr,
    }
    const res = await reqHandleKeywordsLibraryList(params)
    if (res.code === "200") {
      let clearArr = this.state.tableCheckChecked;
      let table = this.state.table;
      for (let i = 0; i < clearArr.length; i++) {
        if(clearArr[i] === true) {
          table[i].is_add = true
        }
        clearArr[i] = false
      }
      this.setState({
        addLoadingStatus: false,
        checked: false,
        tableCheckChecked: clearArr,
        table,
      }, () => {
        this.updateKeywordsList()
      })
      this.props.toggleToast(res.msg, false)
    } else {
      this.setState({
        addLoadingStatus: false
      }, () => {
        this.props.toggleToast(res.msg, true)
      })
    }
  }

  updateKeywordsList = () => {
    //表格ID
    let tableInputIDArr = [];
    for (var i = 0; i < this.state.table.length; i++) {
      tableInputIDArr.push(this.state.table[i].id);
    }

    let myKeywordsList = this.state.table.map((item, index) => {
      let checkbox_content = <div style={{ paddingLeft: "8px" }}>
        <Checkbox
          checked={this.state.tableCheckChecked[index]}
          onChange={this.changeCheckbox.bind(this, index)}
        />
      </div>;
      let kdColor = item.kd <= 40 ? 'ScoreItemGreen' : item.kd <= 70 ? 'ScoreItemOrange' : 'ScoreItemRed'
      let keyword = <div style={{ width: '20rem', gap: '.5rem' }}>
        <div style={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '14px' }}>{item.keyword}</div>
      </div>;
      let kd = <div className='ScoreItem'>
        <span className={kdColor}>{item.kd}</span>
      </div>;
      let volume = item.volume;
      let tp = item.traffic;
      let cpc = item.cpc;
      let updated_at = item.last_updated_at;
      let my_keywords = <div className='SuccessIcon'>
        {this.state.loadingArr[index] ? <Spinner size="small" /> :
          <span className='InsertIcon' onClick={this.showInsertIcon.bind(this, [item.id], index)}>
            <Icon source={KeywordsResearchInsert}></Icon>
          </span>}
      </div>
      let applyBtn = <div className='apply_keywords' style={{ cursor: 'pointer' }} onClick={() => this.ApplyKeywords(item)}>
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M3.00826 6.61033L0.998785 1.86067C0.643808 1.02164 1.50418 0.183676 2.33356 0.560667L14.4972 6.08961C15.2788 6.44488 15.2788 7.55507 14.4972 7.91034L2.33356 13.4393C1.50418 13.8163 0.643807 12.9783 0.998785 12.1393L3.00826 7.38961C3.11363 7.14054 3.11363 6.85941 3.00826 6.61033ZM4.38971 6.02587L2.87962 2.45656L12.8751 6.99997L2.87962 11.5434L4.38971 7.97407C4.42087 7.90041 4.44835 7.82564 4.47214 7.75H8.25C8.66421 7.75 9 7.41421 9 7C9 6.58579 8.66421 6.25 8.25 6.25H4.47215C4.44836 6.17435 4.42088 6.09955 4.38971 6.02587Z" fill="#4A4A4A" />
        </svg>
      </div>
      let del = <div style={{ display: 'flex', justifyContent: 'center', alignItem: 'center', gap: '.5rem' }}>
        <span className='DeleteIcon' onClick={this.openDeleteModal.bind(this, [item.id])} style={{ cursor: 'pointer' }}><Icon source={KeywordsResearchDeleteIcon} /></span>
      </div>
      return ([
        checkbox_content,
        keyword,
        kd,
        volume,
        tp,
        cpc,
        updated_at,
        my_keywords,
        applyBtn,
        del,
      ]);
    });
    // 空页面判断
    if (myKeywordsList.length > 0) {
      this.setState({
        myKeywordsRow: myKeywordsList,
        isEmpty: false
      })
    } else {
      this.setState({
        myKeywordsRow: myKeywordsList,
        isEmpty: true
      })
    }
  }

  // 打开申请弹窗
  ApplyKeywords = (data) => {
    this.setState({
      applyModalState: true,
      applyKeywordVal: data.keyword,
    })
  }

  //获取关键词库列表
  getKeywordsLibrary = async (sort = '') => {
    const params = {
      type: 1,
      page: this.state.page,
      size: this.state.size,
      sortType: this.state.orderBy,
      sortIndex: this.state.orderBy !== '' ? this.state.sortIndex : '',
      q: this.state.searchValue ? this.state.searchValue : '',
    };
    const res = await reqGetKeywordsLibrary(params);
    if (res.code === "200") {
      var tableInputCheckedArr = [];
      var ScoreStautsArr = [];
      var loadingArr = [];
      //表格ID
      var tableInputIDArr = [];
      for (let i = 0; i < res.data.length; i++) {
        tableInputCheckedArr.push(false)
        ScoreStautsArr.push(res.data[i].status);
        tableInputIDArr.push(res.data[i].id)
        loadingArr.push(false)
      }

      // 更新分页数据
      const maxPage = Math.ceil(res.count / this.state.size);

      var hasPrevious = ""
      var hasNext = ""
      //如果当前页面大于1 且 小于 总分页   上下都为开启
      if (this.state.page > 1 && this.state.page < maxPage) {
        hasPrevious = true;
        hasNext = true;
        //如果当前页面小于等于1 且 小于总分页 下关闭 上开启
      } else if (this.state.page <= 1 && this.state.page < maxPage) {
        hasPrevious = false;
        hasNext = true;
        //如果当前页面大于1 且 大于等于 总分页   下开启 上关闭
      } else if (this.state.page > 1 && this.state.page >= maxPage) {
        hasPrevious = true;
        hasNext = false;
        // 否则都关闭
      } else if (this.state.page <= 1 && this.state.page >= maxPage) {
        hasPrevious = false;
        hasNext = false;
      }

      this.setState({
        table: res.data,
        loading: false,
        total: res.count, //总关键词条数
        hasPrevious: hasPrevious,
        hasNext: hasNext,
        tableCheckChecked: tableInputCheckedArr,
        tableInputID: tableInputIDArr,
        loadingArr,
      }, () => {
        this.updateKeywordsList();
      })

      //删除成功后 将checked置false
      if(this.state.delStatus) {
        this.setState({
          checked: false,
        })
      }
    }

    // 返回结果不loading
    if(res) {
      this.props.loadingStatus(false);
    }
  }

  //查询
  queryGetKeywordsLibrary = debounce( async (sort = '') => {
    if(sort === 'sort'){

    }else{
      this.setState({
        loading: true,
        page: 1,
      });
    }
    const params = {
      type: 1,
      page: this.state.page,
      q: this.state.searchValue ? this.state.searchValue : '',
    };
    const res = await reqGetKeywordsLibrary(params);

    if (res.code === "200") {
      // 更新分页数据
      const maxPage = Math.ceil(res.count / this.state.size);
      var hasPrevious = ""
      var hasNext = ""
      //如果当前页面大于1 且 小于 总分页   上下都为开启
      if (this.state.page > 1 && this.state.page < maxPage) {
        hasPrevious = true;
        hasNext = true;
        //如果当前页面小于等于1 且 小于总分页 下关闭 上开启
      } else if (this.state.page <= 1 && this.state.page < maxPage) {
        hasPrevious = false;
        hasNext = true;
        //如果当前页面大于1 且 大于等于 总分页   下开启 上关闭
      } else if (this.state.page > 1 && this.state.page >= maxPage) {
        hasPrevious = true;
        hasNext = false;
        // 否则都关闭
      } else if (this.state.page <= 1 && this.state.page >= maxPage) {
        hasPrevious = false;
        hasNext = false;
      }

      this.setState({
        table: res.data,
        loading: false,
        total: res.count, //总关键词条数
        hasPrevious: hasPrevious,
        hasNext: hasNext,
      }, () => {
        this.updateKeywordsList()
      })
    }
  }, 500)

  handleClearButtonClick = () => {
    this.setState({
      searchValue: ""
    }, () => {
      this.getKeywordsLibrary()
    })
  }

  componentDidMount() {
    this.getKeywordsLibrary();
  }

  // 确认申请
  handleApplyChange = (confirm = -1) => {
    let { applyKeywordVal, applyData, applyLists, homeKey } = this.state;
    let listPar = {}; 
    let typeAll = {
      "Products": "product",
      "Collections": "collection",
      "Blogs": "blog",
      "Other Pages": "page",
    }
    let operaList = [];
    Object.keys(applyData).forEach(item => {
      if(applyData[item].length > 0) {
        operaList.push({
          tag: item,
          list: applyData[item]
        });
        if(item === "Homepage") {
          listPar.home = applyData[item];
        } else {
          listPar[typeAll[item]] = applyData[item];
        }
      }
    })
    let isExitState = false, exitNums = 0;
    operaList.forEach(item => {
      if(item.tag === "Homepage") {
        if(homeKey !== '') {
          isExitState = true;
          exitNums += 1;
        }
      } else {
        applyLists[item.tag].list.forEach(obj => {
          if(item.list.includes(obj.id) && obj.primary_keywords) {
            isExitState = true;
            exitNums += 1;
          }
        })
      }
    })
    if(isExitState && confirm === -1) {
      // 提示关键词存在
      let nodeDom = document.querySelector('.apply_keyword_list');
      if(nodeDom && nodeDom.parentNode.parentNode) {
        nodeDom.parentNode.parentNode.style.display = 'none';
      }
      this.setState({
        isShowKeywordExit: true,
        exitNums,
      })
    } else {
      this.setState({
        applyLoading: true,
      }, async() => {
        let params = {
          keyword: applyKeywordVal,
          list: listPar
        }
        const res = await reqAddKeywords(params);
        if(res.ack === 1) {
          // this.props.toggleToast(res.msg);
          this.props.toggleToast(t("Sucessfully"));
          this.setState({
            applyModalState: false,
            isShowKeywordExit: false,
            exitNums: 0,
          })
        } else {
          this.setState({
            applyModalState: false,
            isShowKeywordExit: false,
            exitNums: 0,
          })
          this.props.toggleToast(t("Try again later"), true);
        }

        if(res) {
          this.setState({
            applyLoading: false,
          })
        }
      })
    }
  }

  // 关闭申请弹窗
  handleApplyCancel = () => {
    this.setState({
      applyModalState: false,
    })
  }

  // 选中数据
  changeSelectApply = (data, lists, homeKey) => {
    this.setState({
      applyData: data,
      applyLists: lists,
      homeKey,
    })
  }

  // 关闭
  handleExitClose = () => {
    let nodeDom = document.querySelector('.apply_keyword_list');
    if(nodeDom && nodeDom.parentNode.parentNode) {
      nodeDom.parentNode.parentNode.style.display = 'flex';
    }
    this.setState({
      isShowKeywordExit: false,
    })
  }

  // 确认覆盖关键词
  handleExitConfirm = () => {
    let nodeDom = document.querySelector('.apply_keyword_list');
    if(nodeDom && nodeDom.parentNode.parentNode) {
      nodeDom.parentNode.parentNode.style.display = 'flex';
    }
    this.setState({
      isShowKeywordExit: false,
    }, () => {
      this.handleApplyChange(1)
    })
  }
  
  // 选择表格条数
  changePageSize = (e) => {
    this.setState({
        page: 1,
        size: Number(e),
        current_PageSize: Number(e),
        loading: true,
    }, () => {
      this.getKeywordsLibrary()
    })
  }

  render() {
    const {
      state: {
        checked,
        myKeywordsRow,
        myKeywordsListLength,
        loading,
        orderBydirection,
        headingIndex,
        searchValue,
        isEmpty,
        page,
        total,
        size,
        hasPrevious,
        hasNext,
        tableCheckChecked,
        tableInputID,
        openAddKeywordsStatus,
        openImportKeywordsStatus,
        openDeleteStatus,
        deleteArr,
        delSaveStatus,
        addLoadingStatus,
        current_PageSize,
        applyModalState,
        applyKeywordVal,
        applyData,
        isShowKeywordExit,
        exitNums,
        applyLoading,

      },
      getKeywordsLibrary,
      handleChangeAllCheckbox,
      handleSort,
      handleSearchChange,
      AddKeywordsChildrenChange,
      batchDeleteModal,
      batchAddModal,
      CloseDeletePop,
      ImportKeywordsChildrenChange,
      DeleteChildrenChange,
      changePageSize
    } = this;

    var showEmpty = "";
    if (total === 0) {
      if (searchValue) {
        showEmpty = <EmptyTableTip content={t("Nothing fits into the category")} overview={t("Please check elsewhere.")} mixheight={"400"} />
      } else {
        showEmpty = <EmptyTableTip content={t("No keywords be added now")} overview={t("please go to add your own keywords.")} mixheight={"400"} />
      }
    }

    let headings = [
      isEmpty ? <div style={{ paddingLeft: "8px" }}>
        <Checkbox
          label=""
          disabled
          checked={checked}
          onChange={handleChangeAllCheckbox}
        />
      </div> : <div style={{ paddingLeft: "8px" }}>
        <Checkbox
          label=""
          checked={checked}
          onChange={handleChangeAllCheckbox}
        />
      </div>,
      t("Keyword"),
      <Tooltip content={t("Keyword Difficulty gives an estimation of how hard it is to rank in the top 10 organic search results for a keyword on a 100-point scale.")}>
        <span className="TitleHover" style={{cursor: 'default'}}>{t("KD")}</span>
      </Tooltip>,
      <Tooltip content={t("An estimation of the average monthly number of searches for a keyword over the latest known 12 months of data.")}>
        <span className="TitleHover" style={{cursor: 'default'}}>{t("Volume")}</span>
      </Tooltip>,
      <Tooltip content={t("Traffic Potential shows the sum of organic traffic that the #1 ranking page for your target keyword receives from all the keywords that it ranks for. Values are cached and might differ slightly between reports.")}>
        <span className="TitleHover" style={{cursor: 'default'}}>{t("TP")}</span>
      </Tooltip>,
      <Tooltip content={t("Cost Per Click shows the average price that advertisers pay for each ad click in paid search results for a keyword.")}>
        <span className="TitleHover" style={{cursor: 'default'}}>{t("CPC")}</span>
      </Tooltip>,
      t("Updated"),
      <Tooltip content={t("Add this keyword to My Keywords")}>
       <span className="TitleHover" style={{cursor: 'default'}}>{t("My keywords")}</span>
      </Tooltip>,
      <Tooltip content={t("Apply this keyword to your store page")}>
       <span className="TitleHover" style={{cursor: 'default'}}>{t("Apply")}</span>
      </Tooltip>,
      "",
    ]

    var addButton = "";
    var deleteButton = "";
    var SelectedQuantityText = "";

    addButton = <Button loading={addLoadingStatus} onClick={() => { batchAddModal(tableCheckChecked, tableInputID) }}><span style={{whiteSpace: 'nowrap'}}>{t("Add to My keywords")}</span></Button>;
    deleteButton = <Button onClick={() => { batchDeleteModal(tableCheckChecked, tableInputID) }}>{t("Delete")}</Button>;
    SelectedQuantityText = myKeywordsListLength +" " + t("selected");

    var sortableData = [false, false, false, true, true, true, true, false]

    if (checked) {
      sortableData = [false, false, false, false, false, false, false, false]
      headings = [
        <div className="headings_div1">
          <div className="headings_div2">
            <div className="Polaris-ResourceList-BulkActions__ButtonGroup">
              <div className="Polaris-ResourceList-CheckableButton Polaris-ResourceList-CheckableButton__CheckableButton--selectMode Polaris-ResourceList-CheckableButton__CheckableButton--selected">
                <div className="headings_div3">
                  <Checkbox
                    checked={checked}
                    onChange={handleChangeAllCheckbox}
                  />
                </div>
                <span className="Polaris-ResourceList-CheckableButton__Label">
                  {SelectedQuantityText}
                </span>
              </div>
              {addButton}
              {deleteButton}
            </div>
          </div>
        </div>,
        <span className='none_text'>{t("Keyword")}</span>,
        <span className='none_text'>{t("KD")}</span>,
        <span className='none_text'>{t("Volume")}</span>,
        <span className='none_text'>{t("TP")}</span>,
        <span className='none_text'>{t("CPC")}</span>,
        <span className='none_text'>{t("Updated")}</span>,
        <span className='none_text'>{t("My keywords")}</span>,
        <span className='none_text'>{t("Apply")}</span>,
        <span className='none_text'>{t("")}</span>,
      ];
    }

    const wwidth = this.props.public.window_width; // 屏幕宽度
    var footerContentMsg = "";
    if (total > 0) {
      const startNum = (page - 1) * size + 1;
      const endNum = page * size > total ? total : page * size;
      // footerContentMsg = t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);
      footerContentMsg = wwidth >= 550 ? <FooterPageSelect changePageSize={changePageSize} startNum={startNum} endNum={endNum} total={total} current_PageSize={current_PageSize} /> : t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, this.state.total);
    }

    const tableLoading = loading ? (
      <div className="DetailReport_Empty_New_div_margin_600">
        <Spinner size="large" color="teal" />
      </div>
    ) : (
      isEmpty ? 
        <>
          <DataTable
            columnContentTypes={[
              "text",
              "text",
              "text",
              "numeric",
              "numeric",
              "numeric",
              "numeric",
              "text",
              "text",
              "text",
            ]}
            headings={headings}
            rows={myKeywordsRow}
            sortable={[false, false, false, false, false, false, false, false]} // 需要排序把false 改成true [false, false, true, true, false, false]
            defaultSortDirection={orderBydirection} //ascending descending none
            initialSortColumnIndex={headingIndex}
            onSort={handleSort}
            verticalAlign="middle"
          />
          {showEmpty}
        </>
       : 
        <div className='keyword_list_table'>
          <DataTable
          columnContentTypes={[
            "text",
            "text",
            "text",
            "numeric",
            "numeric",
            "numeric",
            "numeric",
            "text",
            "text",
            "text",
          ]}
          headings={headings}
          rows={myKeywordsRow}
          sortable={sortableData} // 需要排序把false 改成true [false, false, true, true, false, false]
          defaultSortDirection={orderBydirection} //ascending descending none
          initialSortColumnIndex={headingIndex}
          onSort={handleSort}
          verticalAlign="middle"
        />
        {/* <div className="Polaris-DataTable__Footer">
          {footerContentMsg}
        </div> */}
        {/* <div className="Polaris-DataTable__Footer_right"> */}
        <div className={`justify_center ${current_PageSize > 5 && myKeywordsRow.length > 5 ? 'sticky_footer' : ''}`}>
          <Pagination
            label={footerContentMsg}
            hasPrevious={hasPrevious}
            onPrevious={() => {
              this.setState(({
                page: page - 1,
                checked: false,
                tableCheckChecked: [],
                loading: true,
              }), () => {
                //重新请求列表
                getKeywordsLibrary();
              });
            }}
            hasNext={hasNext}
            onNext={() => {
              this.setState(({
                page: page + 1,
                checked: false,
                tableCheckChecked: [],
                loading: true,
              }), () => {
                //重新请求列表
                getKeywordsLibrary();
              });
            }}
          />
          <div className="Polaris-DataTable__Footer_right_button">
          </div>
        </div>

        </div>
      
    );

    // 应用关键词弹窗
    const ApplyKeywordModal = <Modal
      title={t("Apply this keyword to")}
      open={applyModalState}
      onClose={this.handleApplyCancel}
      primaryAction={{
        content: t("Apply"),
        onAction: () => this.handleApplyChange(-1),
        loading: applyLoading,
        disabled: !Boolean(Object.keys(applyData).length > 0 && Object.keys(applyData).filter(item => applyData[item].length > 0).length > 0)
      }}
      secondaryActions={[
        {
          content: t("Cancel"),
          disabled: applyLoading,
          onAction: this.handleApplyCancel,
        },
      ]}
    >
      <ApplyKeywordList 
        mode="multiple"
        applyKeywordVal={applyKeywordVal}
        changeSelectApply={this.changeSelectApply}
      />
    </Modal>

    // 关键词存在提示弹窗
    const KeywordExitModal = <Modal
      title={t("Apply this keyword to this product")}
      open={isShowKeywordExit}
      primaryAction={{
        content: t("Yes"),
        onAction: this.handleExitConfirm,
      }}
      secondaryActions={[
        {
          content: t("Cancel"),
          onAction: this.handleExitClose,
        },
      ]}
      onClose={this.handleExitClose}
    >
      <p style={{ padding: '1rem' }}>
        {t("{{v1}} of the pages you selected contains keywords. Do you want to replace it with new keyword?", exitNums)}
      </p>
    </Modal>

    const pageContent = <div className='DataTable'>
      {ApplyKeywordModal}
      {KeywordExitModal}
      <BlockStack gap={400}>
        <FormLayout>
          <TextField
            value={searchValue}
            onChange={handleSearchChange}
            placeholder={t("search keyword")}
            prefix={<Icon source={SearchMinor} />}
            clearButton
            onClearButtonClick={this.handleClearButtonClick}
          />
        </FormLayout>
        {tableLoading}
      </BlockStack>
      <AddKeywordsModal
        open={openAddKeywordsStatus}
        changeData={AddKeywordsChildrenChange}
      />
      <ImportKeywordsModal
        open={openImportKeywordsStatus}
        changeData={ImportKeywordsChildrenChange}
      />
      <DeleteModal
        open={openDeleteStatus}
        delSaveStatus={delSaveStatus}
        deleteArr={deleteArr}
        changeData={DeleteChildrenChange}
        CloseDeletePop={CloseDeletePop}
      />
    </div>

    return (
      pageContent
    );
  }
}



const mapStateToProps = state => {
  return state
}

KeywordList = connect(
  mapStateToProps,
)(KeywordList);

export default KeywordList;